export default __webpack_public_path__ + "static/media/tick_primary_new_26.f90f4eec.svg";